import { Component } from '@angular/core';
import { apiUrlComponent } from '../common/api.url.component';
import { Router } from '@angular/router';
import { ApiService } from '../common/API/api.service';
import { NotifierService } from 'angular-notifier';
import * as $ from 'jquery';
import { FormGroup, FormBuilder } from '@angular/forms';
import { BackRestrict } from '../common/backRestrict';
import { NgxSpinnerService } from 'ngx-spinner';
import { isNullOrUndefined } from 'util';
declare const config;
@Component({
  selector: 'app-celldetestgroup',
  templateUrl: './warehousetestgroup.component.html',
  styleUrls: ['./warehousetestgroup.component.css']
})
export class WarehousetestgroupComponent {
  public Enterprisedata = [];
  public form: FormGroup;
  public EnterpriseID: any;
  private NotAddedTestList = [];
  private GroupTestList = [];
  private ManageList = [];
  private EnterprisePartnerID;
  EditClick: boolean;
  savebtn: any;
  GdData: boolean;
  private readonly notifier: NotifierService;
  Enterpriselist: any;
  EnterprisePartnerlist: any;
  modfyEnterprisePartnerList: any;
  showUL: boolean;
  AddGroupInfo: boolean;
  disabledSubmitBtn: boolean;
  deductionArray = [];
  deductionVal: any;
  myModal: boolean;
  DeductionInput: boolean;
  WarehouseData: any;
  WarehouseID: any;
  SubscriberProductID: any;
  constructor(
    private backrestrict: BackRestrict, private _apiService: ApiService,
    notifierService: NotifierService, private spinner: NgxSpinnerService
  ) {
    this.notifier = notifierService;
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit() {
    this.EnterpriseID = config.EnterpriseID;
    this.WarehouseID = config.WarehouseID;
    this.backrestrict.clearBrowserBackHistory();
    this.getEnterprise_EnterprisePartner();
    this.GdData = true;
    this.savebtn = false;
    this.disabledSubmitBtn = true;

  }
  getEnterprise_EnterprisePartner() {
    this.spinner.show();
    this._apiService.get(config.WebApiPath + 'api/support-tool/get-store').subscribe(result => {
      this.spinner.hide();
      if (result.IsSuccess) {
        this.Enterpriselist = (result.Data.Table1.filter(X => X.IsActive !== false));
        this.EnterprisePartnerlist = (result.Data.Table2.filter(X => X.IsActive !== false));
        this.Enterprisedata = result.Data.Table2.filter(X => X.EnterpriseID == this.EnterpriseID && X.IsActive !== false);
        this.SubscriberProductID = result.Data.Table3.filter(x => x.WarehouseID == this.WarehouseID)[0].SubscriberProductID;
        this.getTestGrouping();
      }
    },
      error => {
        console.log(error);
      }
    );
    this.spinner.hide();
  }
  onChangeEnterprise(event) {
    this.showUL = false;
    const EnterpriseID = event;
    this.modfyEnterprisePartnerList = this.EnterprisePartnerlist.filter((item) => item.EnterpriseID == EnterpriseID);
  }
  onChangeEnterprisePartner(event) {
    this.showUL = false;
    this.EnterprisePartnerID = event;
    if (event != '0') {
      this.getTestGrouping();
    } else {
      this.disabledSubmitBtn = true;
    }
  }

  getTestGrouping() {
    this.spinner.show();
    // var SubscriberProductID = this.Enterprisedata.filter(x => x.EnterprisePartnerID == this.EnterprisePartnerID)[0].SubscriberProductID;
    const Addbody = {
      WarehouseID: this.WarehouseID,
      SubscriberProductID: this.SubscriberProductID
    };
    this._apiService.post(config.WebApiPath + 'api/support-tool/warehouse-testgroup/', Addbody).subscribe(result => {
      this.spinner.hide();
      if (result !== null) {
        const cellDeData = [];
        this.NotAddedTestList = [];
        this.GroupTestList = [];
        this.showUL = true;
        // if (result.Data.mCheckTestGroup != null || result.Data.mCheckTestGroup != undefined) {
        //   this.NotAddedTestList = JSON.parse(result.Data.mCheckTestGroup).Data.Table2;
        // } else {
        //   this.NotAddedTestList = JSON.parse(result.Data.mCheckTestGroup);
        // }

        if (result.Data.mCheckTestGroup != null || result.Data.mCheckTestGroup != undefined) {
          var mCheckList = JSON.parse(result.Data.mCheckTestGroup).Data.Table.filter(x => (x.DiagnosticTypeID == 2 ||
            x.DiagnosticTypeID == 3));
          mCheckList.forEach(x => {
            this.NotAddedTestList.push({
              TestID: x.TestID,
              Test: x.TestName
            })
          })
        }

        result.Data.CelldeTestGroup.CelldeTestGroup.Table.forEach(X => {
          let testdata: any = [];
          let testName = '';
          let TestID = null;
          if (X.TestID !== null) {
            testdata = this.NotAddedTestList.find(Y => Y.TestID === X.TestID);
            if (!isNullOrUndefined(testdata)) {
              testName = testdata.Test;
              TestID = testdata.TestID;
            }
            this.NotAddedTestList.splice(this.NotAddedTestList.indexOf(this.NotAddedTestList.find(row => row.TestID === X.TestID)), 1);
          }
          cellDeData.push(
            {
              TestID: TestID,
              Test: testName,
              ParentID: X.ParentID,
              ParentTest: X.ParentTest,
              Deduction: X.Deduction,
              bgClass: X.bgClass
            });
        });

        const GroupTest = this.uniqueGroup(cellDeData, function (x) { return x.ParentTest; });
        if (GroupTest.length > 0) {
          GroupTest.forEach(element => {
            const TestList = cellDeData.filter(x => x.ParentTest === element);
            const Index = TestList.findIndex(x => x.TestID === null);
            if (Index >= 0) {
              TestList.push(
                {
                  ParentTest: TestList[Index].ParentTest,
                  ParentID: TestList[Index].ParentID,
                  Deduction: TestList[Index].Deduction,
                  Test: TestList[Index].Test,
                  TestID: TestList[Index].TestID,
                  bgClass: 'd-none',
                  Class: 'd-none'
                });
              TestList.splice(Index, 1);
            }
            this.GroupTestList.push(
              {
                ParentTest: element,
                ParentID: TestList[0].ParentID,
                Deduction: TestList[0].Deduction,
                ChilTestData: TestList,
                bgClass: ''
              }
            );
          });
        }
      }
    },
      error => {
        console.log(error);
      }
    );
  }

  showchildtest(id: any, tabId: any) {
    $('#child_' + id).slideToggle(200);
    $('#iconAngle' + tabId).toggleClass('fa-angle-up fa-angle-down');
  }

  manageGroups() {
    this.spinner.show();
    this.deductionArray = [];
    this.disabledSubmitBtn = true;
    this.ManageList = [];
    this.GroupTestList.forEach(element => {
      if (element.ChilTestData.length > 0) {
        element.ChilTestData.forEach(Childelement => {
          this.ManageList.splice(0, 0,
            {
              ParentTest: element.ParentTest,
              ParentID: element.ParentID,
              TestID: Childelement.TestID,
              Deduction: element.Deduction,
              WarehouseID: parseInt(this.WarehouseID),
            }
          );
        });
      } else {
        this.ManageList.splice(0, 0,
          {
            ParentTest: element.ParentTest,
            ParentID: element.ParentID,
            TestID: null,
            Deduction: element.Deduction,
            // tslint:disable-next-line:radix
            WarehouseID: parseInt(this.WarehouseID),
          }
        );

      }
    });
    this.NotAddedTestList = this.NotAddedTestList.map(o => ({ Test: o.Test, TestID: o.TestID }));
    this.ManageList = this.ManageList.filter(x => x.ParentTest !== null && x.ParentID !== null
      && x.Deduction !== null && x.WarehouseID !== null);

    if (this.ManageList.length < 1) {
      this.ManageList.push({
        ParentTest: null,
        ParentID: null,
        TestID: null,
        Deduction: null,
        // tslint:disable-next-line:radix
        WarehouseID: parseInt(this.WarehouseID),
      });
    }
    if (this.NotAddedTestList.length < 1) {
      this.NotAddedTestList.push({
        Test: 0,
        TestID: 0
      });
    }

    const Parameters = {
      ManageList: this.ManageList,
      NotAddedTestList: this.NotAddedTestList
    };

    this._apiService.post(config.WebApiPath + 'api/updateWarehouseGroups/', Parameters).subscribe(result => {
      this.spinner.hide();
      this.ManageList = [];
      if (result.IsSuccess === true) {
        this.notifier.notify('success', 'Data Updated Successfully');
        this.getTestGrouping();
        this.NotAddedTestList = [];
        this.GroupTestList = [];
        this.GdData = true;
        this.EditClick = false;
        this.savebtn = false;
      } else {
        this.notifier.notify('error', 'An Error Occured');
        this.getTestGrouping();
        this.NotAddedTestList = [];
        this.GroupTestList = [];
        this.ManageList = [];
        this.GdData = true;
        this.EditClick = false;
        this.savebtn = false;
      }
    },
      error => {
        console.log(error);
      }
    );


  }


  onItemDrop(e: any) {
    // tslint:disable-next-line:radix
    const ParentID = parseInt(e.nativeEvent.currentTarget.id);
    const GroupTest = this.GroupTestList.find(x => x.ParentID === ParentID);
    if ((this.NotAddedTestList.filter(x => x.TestID === e.dragData.TestID).length) !== 0) {
      this.NotAddedTestList.splice(this.NotAddedTestList.indexOf(this.NotAddedTestList.find(row => row.TestID === e.dragData.TestID)), 1);
      this.disabledSubmitBtn = false;
    } else {
      if (e.dragData.ParentID === null) {
        this.GroupTestList.forEach(X => {
          if (X.ChilTestData.find(X => X.TestID == e.dragData.TestID)) {
            X.ChilTestData.splice(X.ChilTestData.indexOf(X.ChilTestData.find(row => row.TestID === e.dragData.TestID)), 1);
          }
        });
        // this.isdisabledSubmitBtn();
        this.disabledSubmitBtn = false;
      }
    }
    if ((GroupTest.ChilTestData.filter(x => x.TestID === e.dragData.TestID).length) === 0) {
      if (e.dragData.ParentID === null || e.dragData.ParentID === undefined) {
        GroupTest.ChilTestData.splice(0, 0, {
          ParentID: ParentID,
          TestID: e.dragData.TestID,
          Test: e.dragData.Test,
          bgClass: 'new-added-child '
        });
        this.disabledSubmitBtn = false;
      }
    }
  }

  onItemremove(item: any) {
    if (this.NotAddedTestList.length > 0) {
      if ((this.NotAddedTestList.filter(x => x.TestID === item.TestID).length) === 0) {
        this.NotAddedTestList.splice(0, 0, {
          TestID: item.TestID,
          Test: item.Test,
          PercentageDeduction: item.PercentageDeduction,
          bgClass: 'new-added-child'
        });
        this.disabledSubmitBtn = false;
      }

    } else if (this.NotAddedTestList.length === 0) {
      item.bgClass = 'new-added-child';
      this.NotAddedTestList.splice(0, 0, item);
      this.isdisabledSubmitBtn();
    }

    const dragTestData = this.GroupTestList.find(x => x.ParentID === item.ParentID);
    const childTestData = this.GroupTestList.find(x => x.ParentID === item.ParentID).ChilTestData;
    dragTestData.ChilTestData = childTestData.filter(x => x.TestID !== item.TestID);
  }
  onDropTestGroup(e: any) {
    this.isdisabledSubmitBtn();
    this.GroupTestList.splice(0, 0, {
      ParentTest: e.dragData.Test,
      ParentID: e.dragData.TestID,
      Deduction: 0,
      ChilTestData: [],
      bgClass: 'new-added-group'
    });
    if (this.NotAddedTestList.find(X => X.TestID == e.dragData.TestID)) {
      this.NotAddedTestList.splice(this.NotAddedTestList.indexOf(this.NotAddedTestList.find(row => row.TestID === e.dragData.TestID)), 1);
    } else {
      this.GroupTestList.forEach(X => {
        if (X.ChilTestData.find(X => X.TestID == e.dragData.TestID)) {
          X.ChilTestData.splice(X.ChilTestData.indexOf(X.ChilTestData.find(row => row.TestID === e.dragData.TestID)), 1);
        }
      });
    }
  }
  Reset() {
    this.disabledSubmitBtn = true;
    this.savebtn = false;
    this.deductionArray = [];
    this.getTestGrouping();
    this.notifier.notify('success', 'Reset Successfully');
  }

  editDeduction(Id: any) {
    this.showEditTextToggle(Id);
    if (this.deductionArray.length > 0) {
      for (let i = 0; this.GroupTestList.length > i; i++) {
        if ((this.deductionArray.find(X => X.ParentID === this.GroupTestList[i].ParentID)) === null) {
          this.deductionArray.splice(0, 0, {
            // tslint:disable-next-line:radix
            Deduction: parseInt($('#DeductionTB' + i).val()),
            // tslint:disable-next-line:radix
            UpdatedDeduction: parseInt($('#DeductionTB' + i).val()),
            ID: i,
            ParentID: this.GroupTestList[i].ParentID
          });
        }
      }
    } else {
      for (let i = 0; this.GroupTestList.length > i; i++) {
        this.deductionArray.push({
          // tslint:disable-next-line:radix
          Deduction: parseInt($('#DeductionTB' + i).val()),
          // tslint:disable-next-line:radix
          UpdatedDeduction: parseInt($('#DeductionTB' + i).val()),
          ID: i,
          ParentID: this.GroupTestList[i].ParentID
        });
      }
    }
    // this.savechanges(Id, parentID);



  }

  showEditTextToggle(Id: any) {
    $('#btnsave' + Id).toggleClass('d-inline-block');
    $('#btnEdit' + Id).toggleClass('d-none');
    $('#iconUndo' + Id).toggleClass('d-inline-block');
    $('#DeductionLB' + Id).toggleClass('d-none');
    $('#DeductionTB' + Id).toggleClass('d-inline-block');
  }
  undoDeduction(Id: any, ParentID: any) {
    this.savebtn = false;
    this.showEditTextToggle(Id);
    const deduction = this.deductionArray.find(x => x.ParentID == ParentID);
    $('#DeductionTB' + Id).val(deduction.Deduction);
    $('#DeductionLB' + Id).text('Deduction : ' + deduction.Deduction + '%');
    this.GroupTestList.filter(x => {
      // tslint:disable-next-line:triple-equals
      if (x.ParentID == ParentID) {
        // tslint:disable-next-line:radix
        x.Deduction = parseInt(deduction.Deduction);
        x.bgClass = '';
      }
    });
    this.deductionArray.filter(x => {
      if (x.ParentID == ParentID) {
        // tslint:disable-next-line:radix
        x.UpdatedDeduction = parseInt(deduction.Deduction);
      }
    });
    // if (this.GroupTestList.filter(X => X.bgClass === '').length === this.GroupTestList.length) {
    //   this.disabledSubmitBtn = true;
    // }

  }

  savechanges(Id: any, parentID) {
    // tslint:disable-next-line:radix
    const deductionval = parseInt($('#DeductionTB' + Id).val());
    if (deductionval <= 100 && deductionval >= 0) {
      this.showEditTextToggle(Id);
      // tslint:disable-next-line:radix
      if (this.deductionArray[Id].UpdatedDeduction !== parseInt($('#DeductionTB' + Id).val())) {
        // tslint:disable-next-line:radix
        this.GroupTestList[Id].Deduction = parseInt($('#DeductionTB' + Id).val());
        // tslint:disable-next-line:radix
        this.deductionArray[Id].UpdatedDeduction = parseInt($('#DeductionTB' + Id).val());
        this.GroupTestList[Id].bgClass = 'new-added-group';
        this.isdisabledSubmitBtn();
        const deduction = this.deductionArray.find(x => x.ParentID === parentID);
        $('#DeductionTB' + Id).val(deduction.UpdatedDeduction);
        $('#DeductionLB' + Id).text('Deduction : ' + deduction.UpdatedDeduction + '%');
      }
      // tslint:disable-next-line:radix
      if (this.deductionArray[Id].Deduction === parseInt($('#DeductionTB' + Id).val())) {
        this.GroupTestList[Id].bgClass = '';
      }
    } else {
      $('#validationModel').click();
      $('#DeductionTB' + Id).val('');
    }
  }
  isdisabledSubmitBtn() {
    let count = 0;
    for (let i = 0; this.GroupTestList.length > i; i++) {
      if ($('#DeductionTB' + i).attr('class') !== 'form-control d-none d-inline-block') {
        count++;
      }
    }
    if (count === this.GroupTestList.length) {
      this.disabledSubmitBtn = false;
    } else {
      this.disabledSubmitBtn = true;
    }
  }

  DeleteGroup(Id: any) {
    this.isdisabledSubmitBtn();
    let newList = [];
    newList = this.GroupTestList.filter(x => x.ParentID === Id);
    newList.forEach(Y => {
      Y.ChilTestData.forEach(X => {
        if (X.TestID != null) {
          this.NotAddedTestList.splice(0, 0, {
            TestID: X.TestID,
            Test: X.Test,
            PercentageDeduction: null,
            bgClass: 'new-added-group'
          });
        }

      });
      this.NotAddedTestList.splice(0, 0, {
        TestID: Y.ParentID,
        Test: Y.ParentTest,
        PercentageDeduction: null,
        bgClass: 'new-added-group'
      });
    });
    this.GroupTestList.splice(this.GroupTestList.indexOf(this.GroupTestList.find(row => row.ParentID === Id)), 1);

  }


  uniqueGroup(arr, fn) {
    const unique = {};
    const distinct = [];
    arr.forEach(function (x) {
      const key = fn(x);
      if (!unique[key]) {
        distinct.push(key);
        unique[key] = true;
      }
    });
    return distinct;
  }


  keyPressNumbers(event: any) {
    const pattern = /^[0-9]*$/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
